import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dropzone']
  static values = {
    container: String
  }

  connect () {
    this.#setupDragAndDrop()
  }

  #setupDragAndDrop () {
    // Prevent default browser behavior for the entire page
    document.addEventListener('dragover', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    document.addEventListener('drop', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    // Handle the dropzone specifically
    const dropzone = this.dropzoneTarget

    dropzone.addEventListener('dragover', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.add('drag-over')
    })

    dropzone.addEventListener('dragleave', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.remove('drag-over')
    })

    dropzone.addEventListener('drop', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.remove('drag-over')

      const files = e.dataTransfer.files
      if (files.length > 0) {
        this.uploadFiles(files)
      }
    })
  }

  async uploadFiles (files) {
    const formData = new FormData()
    for (let i = 0; i < files.length; i++) {
      formData.append('files[]', files[i])
    }
    formData.append('container', this.containerValue)

    try {
      this.dropzoneTarget.classList.add('opacity-50', 'cursor-wait')
      const response = await fetch('/bulk_uploads', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          Accept: 'application/json'
        }
      })

      if (response.ok) {
        await response.json()
        window.location.reload()
      } else {
        console.error('Upload failed')
      }
    } catch (error) {
      console.error('Upload error:', error)
    } finally {
      this.dropzoneTarget.classList.remove('opacity-50', 'cursor-wait')
    }
  }
}
